import { ComponentType } from 'react'
import { BrowserRouter } from 'react-router-dom'

export default (WrappedComponent: ComponentType) => {
  const Component = ({ ...props }) => (
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <WrappedComponent {...props} />
    </BrowserRouter>
  )

  return Component
}
